"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeLetterCase = void 0;
function makeLetterCase(selectedType) {
    return (selectedType.substring(0, 1).toUpperCase() +
        selectedType.substring(1, selectedType.length).toLowerCase());
}
exports.makeLetterCase = makeLetterCase;
